"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = require("HubStyleTokens/colors");

var _AvatarWrapper = _interopRequireDefault(require("./AvatarWrapper"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _default = (0, _styledComponents.default)(_AvatarWrapper.default).withConfig({
  displayName: "AvatarWrapperOverlay",
  componentId: "axniyx-0"
})(["& .overlay-content{align-items:center;background:", ";color:", ";cursor:pointer;display:flex;font-family:sans-serif;height:0;hyphens:auto;justify-content:center;left:0;opacity:0;overflow:visible;padding:calc(50%);position:absolute;text-align:center;top:0;transition:opacity 300ms ease;width:0;}&:hover .overlay-content,&.hover-test .overlay-content{opacity:0.85;}"], _colors.SLINKY, _colors.OLAF);

exports.default = _default;
module.exports = exports.default;